import { useMutation, useQueryClient } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { backend } from '../axios/backend';
import PrettyLoader from '../components/PrettyLoader';
import ProductForm from '../components/ProductForm';
import Breadcrumbs from '../components/ui/Breadcrumbs';
import { useAppContext } from '../context/AppContext';
import { useWish } from '../hooks/useWish';
import { Product } from '../types/product';
import { parseErrorMessage } from '../utils/error-message';

const EditWishPage = () => {
  const { wishId } = useParams();
  const navigate = useNavigate();

  const { alertSuccess, alertError } = useAppContext();

  const queryClient = useQueryClient();
  const query = useWish(wishId);
  const mutation = useMutation(
    async (options: Partial<Product>) => await backend.patch(`wish/my/${query.data?.id}`, options),
    {
      onSuccess: () => {
        alertSuccess('Wunsch bearbeitet');
        queryClient.invalidateQueries('my-wishes');
        navigate('/my-wishes');
      },
      onError: (e, options) => {
        console.log(options);
        alertError(parseErrorMessage(e));
      },
    },
  );

  return (
    <div style={{ margin: '2rem' }} className="space-y-4">
      <Breadcrumbs
        crumbs={[
          { text: 'Meine Wünsche', route: '/my-wishes' },
          { text: `${query.data?.name}`, route: `/my-wish/${wishId}` },
          { text: 'bearbeiten', route: '/edit-wish/' + wishId },
        ]}
      />
      <h1 className="text-white text-xl">
        <b>Wunsch bearbeiten</b>
      </h1>
      <PrettyLoader useQueryResult={query}>
        {query.data && (
          <ProductForm
            product={query.data}
            onSubmit={mutation.mutate}
            isLoading={mutation.isLoading}
            submitText="Wunsch bearbeiten"
            type="wish"
          />
        )}
      </PrettyLoader>
    </div>
  );
};

export default EditWishPage;
